module.exports = __webpack_public_path__ + "img/KK.4c14213c.png";